import { num } from "../data"
import { lastsDays } from "../stock"

export interface SiteRow {
  warehouse: string
  qty: number
  move: number | null // average units out per day; null when the warehouse serves no channel
}

function Doc({ qty, move }: { qty: number; move: number | null }) {
  if (move === null) return <>—</>
  const days = lastsDays(qty, move)
  return days === null ? <span className="font-semibold">No movement</span> : <>{num(days)}</>
}

// Stock per warehouse with a total row. The same table on High DOC (the whole
// product) and Expiring soon (one batch).
export default function SitesTable({ rows }: { rows: SiteRow[] }) {
  const total = {
    qty: rows.reduce((sum, r) => sum + r.qty, 0),
    // Blank when no warehouse here serves a channel, so nothing is known.
    move: rows.every((r) => r.move === null) ? null : Math.round(rows.reduce((sum, r) => sum + (r.move ?? 0), 0) * 10) / 10,
  }

  return (
    <table className="w-full text-sm">
      <thead className="bg-muted/60 text-xs font-semibold uppercase tracking-wide">
        <tr>
          <th className="px-4 py-2 text-left">Warehouse</th>
          <th className="px-4 py-2 text-right">Qty</th>
          <th className="px-4 py-2 text-right">Avg Daily Stock Move</th>
          <th className="px-4 py-2 text-right">DOC</th>
        </tr>
      </thead>
      <tbody className="divide-y tabular-nums">
        {rows.map((row) => (
          <tr key={row.warehouse}>
            <td className="px-4 py-2 font-medium">{row.warehouse}</td>
            <td className="px-4 py-2 text-right">{num(row.qty)}</td>
            <td className="px-4 py-2 text-right">{row.move === null ? "—" : num(row.move)}</td>
            <td className="px-4 py-2 text-right"><Doc qty={row.qty} move={row.move} /></td>
          </tr>
        ))}
        <tr className="border-t bg-muted/30 font-semibold">
          <td className="px-4 py-2">Total</td>
          <td className="px-4 py-2 text-right">{num(total.qty)}</td>
          <td className="px-4 py-2 text-right">{total.move === null ? "—" : num(total.move)}</td>
          <td className="px-4 py-2 text-right"><Doc qty={total.qty} move={total.move} /></td>
        </tr>
      </tbody>
    </table>
  )
}
